import SolutionsBanner from './Home/SolutionsBanner';
import SolutionsOptions from './Home/SolutionsOptions';
import SolutionsBrands from './Home/SolutionsBrands';
import SolutionsRange from './Home/SolutionsRange';
import SolutionsFinance from './Home/SolutionsFinance';
import SolutionsCTA from './Home/SolutionsCTA';

export default function SolutionsPage() {
  return (
    <div>
      <SolutionsBanner />
      <SolutionsOptions />
      <SolutionsBrands />
      <SolutionsRange />
      <SolutionsFinance />
      <SolutionsCTA />
    </div>
  );
}
